import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpanish = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_198_10506)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0 7.99973C0 8.9783 0.176031 9.91567 0.497594 10.7823L8 11.478L15.5024 10.7823C15.824 9.91567 16 8.9783 16 7.99973C16 7.02117 15.824 6.0838 15.5024 5.21714L8 4.52148L0.497594 5.21714C0.176031 6.0838 0 7.02117 0 7.99973H0Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.5029 5.21741C14.3725 2.17103 11.4402 0 8.00045 0C4.56073 0 1.62839 2.17103 0.498047 5.21741H15.5029Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.498047 10.7822C1.62839 13.8286 4.56073 15.9996 8.00045 15.9996C11.4402 15.9996 14.3725 13.8286 15.5029 10.7822H0.498047Z",
					fill: "#D80027"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_198_10506",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSpanish);
export { ForwardRef as ReactComponent };
